<div
  capraTooltip
  [tooltipContent]="copyTooltipHtml"
  tooltipSize="mini"
  tooltipPlacement="bottom"
  [tooltipContentIsHtml]="true"
>
  <capra-button
    *ngIf="content$ | async as content"
    variant="secondary"
    color="neutral"
    size="small"
    [text]="copyButtonHtml"
    [disabled]="copyDisabled"
    modeClipboard
    [clipboardText]="largeDatasetForCopy"
    (clicked)="downloadOrCopyDataset($event, content)"
    data-test="copy-dataset-button"
  ></capra-button>
</div>
